import { flow } from 'lodash';

import { NAME } from './dialogSelectAllDebits.constant';

import { selectState as selectStateDialogs } from '../dialogs.selector';

const selectStateKey = (state) => state[NAME];
const selectVisibleKey = (state) => state.visible;
const selectPayloadKey = (state) => state.payload;

export const selectState = flow(selectStateDialogs, selectStateKey);
export const selectVisible = flow(selectState, selectVisibleKey);
export const selectPayload = flow(selectState, selectPayloadKey);
